import { motion } from "framer-motion";

const WORDS = [
  "Mere tid",
  "Mindre drift",
  "Premium hospitality",
  "Boutique co-hosting",
  "Hotelstandard",
  "Hands-off ejerskab",
];

export default function Manifesto() {
  return (
    <section
      data-testid="manifesto-section"
      className="bg-[#111111] text-white relative overflow-hidden py-16 sm:py-28"
    >
      {/* Marquee */}
      <div className="absolute top-10 left-0 right-0 overflow-hidden opacity-[0.07] pointer-events-none select-none">
        <div className="flex marquee-track whitespace-nowrap">
          {[...WORDS, ...WORDS, ...WORDS].map((w, i) => (
            <span
              key={i}
              className="font-serif text-[14vw] leading-none px-8"
              style={{ fontFamily: "Fraunces, serif" }}
            >
              {w} ·
            </span>
          ))}
        </div>
      </div>

      <div className="relative max-w-6xl mx-auto px-6 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: "easeOut" }}
        >
          <p className="overline mb-8" style={{ color: "#D4AF37" }}>
            <span className="inline-block w-10 h-px bg-[#D4AF37] align-middle mr-4" />
            Vores markedsføring
          </p>

          <blockquote
            className="font-serif text-[1.75rem] sm:text-5xl lg:text-6xl font-light leading-[1.15] tracking-tight text-white max-w-5xl"
            style={{ fontFamily: "Fraunces, serif" }}
          >
            &ldquo;Vi markedsfører aktivt din bolig på{" "}
            <span className="italic text-[#D4AF37]">alle relevante bookingplatforme</span>{" "}
            - og direkte her på hjemmesiden - så du får{" "}
            <span className="italic text-[#D4AF37]">flere bookinger</span>, højere belægning og en større
            indtjening som boligejer.&rdquo;
          </blockquote>

          <div className="mt-12 flex items-center gap-5">
            <span className="h-px w-16 bg-[#D4AF37]" />
            <span className="text-xs tracking-[0.3em] uppercase text-white/70">
              Gudiksen Stays · Sæby, Danmark
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
